import { Tabs } from "antd";
import styled from "styled-components";
import theme from "../../../../styles/defaultTheme";

const { TabPane } = Tabs;

export const SearchedContainer = styled.div`
    display: flex;
    padding: 8px;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 20px;
`;

export const FilterBox = styled.div`
    width: 35%;
    border-radius: 8px;
    background-color: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.borderWhite};
    padding: 16px;
    height: fit-content;

    .title {
        font-size: ${theme.font.size24};
    }

    .icon-label {
        color: ${theme.colorsNormal.orange};
        font-size: ${theme.font.size15};
        padding-right: 10px;
    }
`;

export const FilterIcons = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
`;

export const ResultContainer = styled.div`
    margin: 0 32px;
`;

export const StyledTabs = styled(Tabs)`
  margin-left: 60px;
  & .ant-tabs-tab:not(.ant-tabs-tab-active) {
	  color: ${(props) => props.theme.greyLink};
  }

  & .ant-tabs-tab-btn {
    font-weight: bold;
    font-size: ${theme.font.size24};
    
    &:hover, &:focus {
      color: inherit;
    }
  }

  & .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.theme.black};
  }

  & .ant-tabs-ink-bar {
    background: ${(props) => props.theme.orange} !important;
  }

  & .ant-tabs {
    
  }
`;

export const StyledTabPane = styled(TabPane)`
  color: ${(props) => props.theme.black};
  padding-left: 50px;
`;

export const UnitiesBox = styled.div`
    width: 90%;
    border-radius: 8px;
    background-color: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.borderWhite};
    padding: 24px;
    display: flex;
    flex-direction: column;

    & + & {
    margin-top: 24px;
  }
`;

export const StyledTittle = styled.span`
   font-size: ${theme.font.size18};
   font-weight: bold;
`;

export const UnitiesIcons = styled.div`
    .info-icons {
      display: flex;
      align-items: center;
      margin: 24px 0 0 0;

    & span {
        color: ${(props) => props.theme.greyLink} ;
        margin: 0 0 0 8px;
     }
    }

`;

export const ContainerDetailButton = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 24px;

    @media screen and (max-width: 950px) {
        flex-direction: column;
        gap: 0;
    }
`;

export const StyledModalBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 400px;
`;

export const StyledDetailsContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
`;

export const StyledDetailsRoute = styled.div`
  margin-left: 30px;
  .form {
    display: flex;
    align-items: flex-start;
    width: 100%;
    
    & button {
        margin-left: 25px;
    }

    & > div {
        margin: 0; 
        width: 404px; 
    }

    @media (max-width: 900px) {
        flex-direction: column;
        margin: 0;

        & div,
        & button {
            width: 100%;
        }

        & button {
            margin: 10px 0;
            margin-bottom: 25px;
        }

        & input {
            width: 100%;
        }
    }
  }

  .map {
    display: flex;
    margin-top: 20px;
  }
`;

export const StyledInfos = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 30px;

  .result {
    font-weight: bold;
  }
`;

export const TableContainer = styled.div`
  margin: 25px 0px;
  width: fit-content;
`;

export const FilterButton = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    cursor: pointer;

    span {
        font-size: ${theme.font.size16};
        font-weight: bold;
        text-decoration: underline;
        color: ${(props) => props.theme.orangeLink};
        cursor: pointer;
        width: max-content;

        &.active {
            color: ${(props) => props.theme.orangeLink};
            cursor: pointer;
        }
    }
`;